<template>
    <v-container fluid>
        <v-layout align-start>
            <v-btn light outline @click="$router.push('/')">
                <v-icon>keyboard_arrow_left</v-icon>Home
            </v-btn>
        </v-layout>
         <v-card class="card--flex-toolbar mx-5 my-5 elevation-24">
          <v-toolbar card prominent>
            <v-flex xs12>
                <Profile v-if="profile" :profile="profile" icon="power_settings_new" @logout="logout" />
            </v-flex>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-text>
                <div v-if="!profile" id="firebaseui-auth-container" />
                <v-list>
                  <v-subheader>Created</v-subheader>
                    <Preview v-for="prono in babies" :key="prono.id" :id="prono.id" :uid="profile.id" />
                    <v-divider />
                  <v-subheader>Participated</v-subheader>
                    <Preview v-for="prono in pronos" :key="prono.id" :id="prono.id" :uid="profile.id" />
              </v-list>
          </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { firestore, ui, uiConfig, auth } from "@/firebase";
import Profile from "@/components/user/Profile";
import Preview from "@/components/baby/Preview";

export default {
  data() {
    return {
      profile: null,
      pronos: [],
      babies: []
    };
  },
  mounted() {
    // The start method will wait until the DOM is loaded.
    if (auth.currentUser) {
      this.get_profile(auth.currentUser);
    } else {
      this.start_ui();
    }
  },
  watch: {
    profile(profile) {
      if (profile && profile.id) {
        this.$bind(
          "pronos",
          firestore
            .collection("users")
            .doc(profile.id)
            .collection("pronos")
        );
        this.$bind(
          "babies",
          firestore
            .collection("babies")
            .where('parent', '==', profile.id)
        );
      }
    }
  },
  methods: {
    async logout() {
      await auth.signOut();
      this.profile = null;
      this.start_ui();
    },
    start_ui() {
      ui.start("#firebaseui-auth-container", {
        ...uiConfig,
        callbacks: {
          signInSuccessWithAuthResult: res => {
            this.get_profile(res.user);
          }
        }
      });
    },
    get_profile(user) {
      this.profile = {
        name: user.displayName,
        picture: user.photoURL,
        email: user.email,
        id: user.uid
      };
    },
    remove(id) {
      firestore
        .collection("babies")
        .doc(id)
        .delete();
    }
  },
  components: {
    Profile,
    Preview
  }
};
</script>
